import { CreatorsClient } from '@bounty/creators-common/libs/creators'
import { HomeScreen } from '@bounty/creators-common/screens/brands/Home'
import { GetStaticPropsWithSEO } from '@bounty/creators-common/types'
import { ReactElement } from 'react'
import { Layout } from '../../Layout'
import { withSEO } from '../../withSEO'
import { NextPageWithLayout } from '../_app'

export const getStaticProps: GetStaticPropsWithSEO = async () => {
  const shopsResp = await new CreatorsClient().getStores()

  return {
    props: {
      fallback: {
        [CreatorsClient.produceCacheKey('getStores')]: shopsResp,
      },
      seo: {
        title: 'Bounty | Automate UGC for Your Brand',
        description:
          'Use Bounty to get UGC for your brand automatically. Get your brand in front of the right audience using Bounty’s network of influencers.',
      },
    },
  }
}

const Page: NextPageWithLayout = withSEO(HomeScreen)

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

export default Page
